<template>
	<div class="wrapper">
		<div class="topTextArea">
			<div class="topTitle">
				<img class="topTitleImg" src="@/assets/image/vipCenter/vip_text.png" alt="">
			</div>
			<div class="topSubtitle" style="font-weight: bold;">权益重磅升级</div>
			<div class="topSubtitle">成<span style="color: #eecd8f">“达人”</span>赚<span style="color: #eecd8f">“收益”</span></div>
		</div>
		<div class="vipBanner">
			<img src="@/assets/image/vipCenter/bg_decorat.png" alt="" class="advertisementImg">
		</div>
		<div class="advertisement">
			<img src="@/assets/image/vipCenter/advertising.png" alt="" class="advertisementImg">
		</div>
		<div class="commonWrapper centerAction">
			<div class="centerActionText">成为<span class="pointText">电巢VIP</span>会员，你<span class="pointText">“赚到”</span>的不仅仅是一点点</div>
			<div class="actionButton" @click="callNativeApp">戳我立即入会</div>
		</div>
		<div class="commonWrapper">
			<div class="rightsTitle">电巢VIP会员尊享权益</div>
			<div class="rightsWrapper">
				<div class="rightItem" v-for="right of rightList" :key="right.title">
					<div class="rightIconWrapper">
						<img :src="right.icon" alt="" class="rightIcon">
					</div>
					<div class="rightText">{{right.title}}</div>
				</div>
			</div>
		</div>
		<div class="commonWrapper bottomArea">
			<!-- <div class="userAvatarWrapper">
				<div class="avatarItemWrapper">
					<img src="" alt="" class="userAvatar">
				</div>
				<div class="avatarItemWrapper">
					<img src="" alt="" class="userAvatar">
				</div>
				<div class="avatarItemWrapper">
					<img src="" alt="" class="userAvatar">
				</div>
				<div class="avatarItemWrapper">
					<img src="" alt="" class="userAvatar">
				</div>
				<div class="avatarItemWrapper">
					<img src="" alt="" class="userAvatar">
				</div>
				<div class="moreAvatarItemWrapper">
					<img src="" alt="" class="userAvatar">
				</div>
			</div> -->
			<div class="members">
				<img src="@/assets/image/vipCenter/members.png" alt="" class="memberImg">
			</div>
			<div class="userAvatarText">圈子里的人都来了</div>
		</div>
	</div>
</template>

<script>
import utils from '@/utils/utils'
import {apppagebase, pagehost} from '@/utils/http'
import WxShare from '@/utils/wxshare'
export default {
	data(){
		return {
			fuid: this.$route.query.fuid || 0,
			rightList: [{title: '免费进EMEA特战营', icon: require('../../assets/image/vipCenter/right_class.png')}, {title: '免费用巣粉引擎', icon: require('../../assets/image/vipCenter/right_engine.png')}, {title: '免费听全领域课程', icon: require('../../assets/image/vipCenter/right_course.png')}, {title: '免费供成熟方案', icon: require('../../assets/image/vipCenter/right_ways.png')}, {title: '扩人脉~荐就业', icon: require('../../assets/image/vipCenter/right_society.png')}, {title: '免费享OPENLA', icon: require('../../assets/image/vipCenter/right_openla.png')}, {title: '带你拿返利', icon: require('../../assets/image/vipCenter/right_reward.png')}, {title: '全程专家辅导', icon: require('../../assets/image/vipCenter/right_teacher.png')}]
		}
	},
	mounted(){
		this.init()
	},
	methods: {
		init(){
			new WxShare().share({
				title: '这可能是目前晋升年薪50W最好的机会了',
				desc: '电子人蜕变成长宝藏指南！',
				link: window.location.href,
				imgUrl: pagehost + '/images/common/logo.jpeg'
			})
		},
		callNativeApp(){
			let path = encodeURIComponent(`http/${apppagebase.replace('http://', '')}/vipCenter?hideNativeNav=1&fuid=${this.fuid}`)
			utils.callNativeApp(path)
		}
	}
}
</script>

<style scoped>
.wrapper{
	padding: 15px;
	/*background-color: #242222;*/
	background-color: #000;
	text-align: center;
}
.topTitle{
	font-size: 40px;
	color: #e8b866;
}
.topTitleImg{
	height: 55px;
	width: auto;
}
.topSubtitle{
	margin-bottom: 10px;
	font-size: 30px;
	color: #fff;
}
.vipBanner{
	min-height: 100px;
	margin-top: 20px;
}
.advertisement{
	min-height: 270px;
	margin-bottom: 10px;
}
.advertisementImg{
	width: 100%;
	height: auto;
}
.commonWrapper{
	padding: 15px;
	margin-bottom: 10px;
	background-color: #313234;
	border-radius: 10px;
	overflow: hidden;
}
.centerActionText{
	font-size: 16px;
	color: #fdead0;
}
.pointText{
	font-size: 20px;
	font-weight: 500;
}
.actionButton{
	height: 42px;
	line-height: 42px;
	margin: 20px auto 10px;
	font-size: 18px;
	font-weight: 500;
	color: #835b2a;
	border-radius: 22px;
	background-color: #f0d8a9;
	background-image: linear-gradient(to right, #f0d8a9, #e8b866);
}
.rightsTitle{
	font-size: 18px;
	color: #f8e5ce;
}
.rightsWrapper{
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin: 15px auto;
}
.rightItem{
	width: 25%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 15px;
}
.rightIconWrapper{
	width: 50px;
	height: 50px;
	flex-shrink: 0;
}
.rightIcon{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.rightText{
	margin-top: 5px;
	font-size: 12px;
	color: #a6a9ba;
}
.bottomArea{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 20px;
	padding-bottom: 20px;
}
.userAvatarWrapper{
	display: flex;
}
.avatarItemWrapper{
	width: 35px;
	height: 35px;
	margin-right: -10px;
	border-radius: 50%;
	border: 1px solid #fff;
	box-sizing: border-box;
	background-color: #ccc;
}
.userAvatar{
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.moreAvatarItemWrapper{
	width: 35px;
	height: 35px;
	border-radius: 50%;
	background-color: #f0d8a9;
}
.memberImg{
	height: 35px;
	width: auto;
}
.userAvatarText{
	flex: 1;
	font-size: 16px;
	color: #f8e5ce;
}

</style>
